import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Categories } from '../lib/supabase-types';

export function useCategories() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [categories, setCategories] = useState<Categories[]>([]);

  useEffect(() => {
    const loadCategories = async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from('categories')
          .select('*')
          .order('name');

        if (error) throw error;

        setCategories(data as Categories[]);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  return {
    loading,
    error,
    categories
  };
}